import { OnboardingConfigDTO, OnboardingModuleEnum } from "front-lib";

export const paymentOnboarding: OnboardingConfigDTO = {
    module: OnboardingModuleEnum.SETTINGS_PAYMENT,
    steps: [
        {
            id: "pay-welcome",
            title: "Métodos de Pagamento",
            description:
                "Configure quais formas de pagamento estão disponíveis para motoristas e passageiros na plataforma.",
            position: "center",
        },
        {
            id: "pay-toggles",
            title: "Ativar/Desativar Métodos",
            description:
                "Use os toggles para habilitar ou desabilitar cada método de pagamento: Dinheiro, Cartão, PIX, Mercado Pago.",
            targetId: "payment-toggles",
            position: "bottom",
        },
        {
            id: "pay-priority",
            title: "Prioridade",
            description:
                "Defina a ordem de prioridade dos métodos de pagamento. O primeiro método ativo será o padrão sugerido ao passageiro.",
            targetId: "payment-priority",
            position: "bottom",
        },
        {
            id: "pay-save",
            title: "Salvar Configurações",
            description:
                "Após configurar, salve para que as alterações sejam refletidas imediatamente nos apps.",
            targetId: "payment-save-btn",
            position: "top",
        },
    ],
};
